import { styled, keyframes } from "@pigment-css/react";
import { SidePanelContainer, SidePanelSection, DateColumn, DatedListDivider } from "../ui";
import { Flex } from "../../primitives";

const shimmer = keyframes({
  "0%": { backgroundPosition: "-200px 0" },
  "100%": { backgroundPosition: "200px 0" },
});

const SkeletonElement = styled("div")(({ theme }) => ({
  borderRadius: theme.managementView.radius[10],
  background: `linear-gradient(90deg, ${theme.colors.neutral[200]} 0%, ${theme.colors.neutral[100]} 50%, ${theme.colors.neutral[200]} 100%)`,
  backgroundSize: "400px 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
}));

const HeaderTitleSkeleton = styled(SkeletonElement)({
  height: "28px",
  width: "180px",
});

const HeaderSubtitleSkeleton = styled(SkeletonElement)({
  height: "20px",
  width: "150px",
});

const SectionTitleSkeleton = styled(SkeletonElement)({
  height: "14px",
  width: "120px",
});

const ChipSkeleton = styled(SkeletonElement)(({ theme }) => ({
  height: "32px",
  width: "52px",
  borderRadius: theme.managementView.radius[16],
  flexShrink: 0,
}));

const CompanyNameSkeleton = styled(SkeletonElement)({
  height: "18px",
  width: "160px",
});

const SignalTypeSkeleton = styled(SkeletonElement)({
  height: "16px",
  width: "120px",
});

const DetailItemSkeleton = styled(SkeletonElement)({
  height: "14px",
  width: "80px",
});

const DismissalCardSkeleton = () => (
  <Flex gap={16} align="start" style={{ padding: "12px 0" }}>
    <DateColumn>
      <ChipSkeleton />
    </DateColumn>
    <Flex direction="column" align="start" gap={24} style={{ flex: 1 }}>
      <Flex direction="column" gap={2} align="start" style={{ width: "100%" }}>
        <CompanyNameSkeleton />
        <SignalTypeSkeleton />
      </Flex>
      <Flex gap={12}>
        <DetailItemSkeleton />
        <DetailItemSkeleton />
        <DetailItemSkeleton />
      </Flex>
    </Flex>
  </Flex>
);

export const DismissedCustomersSidePanelSkeleton = () => {
  return (
    <SidePanelContainer>
      <Flex direction="column" gap={8} align="start">
        <HeaderTitleSkeleton />
        <HeaderSubtitleSkeleton />
      </Flex>

      <SidePanelSection title="">
        <Flex direction="column" gap={8} align="start" style={{ marginBottom: "24px" }}>
          <SectionTitleSkeleton />
        </Flex>
        <Flex direction="column">
          <DismissalCardSkeleton />
          <DatedListDivider />
          <DismissalCardSkeleton />
          <DatedListDivider />
          <DismissalCardSkeleton />
        </Flex>
      </SidePanelSection>
    </SidePanelContainer>
  );
};
